import { Log } from 'ng2-logger';
import Types, { GlobalState } from '../../models/action/core.d';
import {
    ISetActiveStudentsData,
    ISetActiveUsersGraphData,
    ISetFrequentlyVisitedCoursesData,
    ISetVirtualClassViewsData
} from '../../models/action/reports';
import * as Actions from '../constants/reports';

const _logger = Log.create('Report Reducer');

const reportReducer = (state = GlobalState().reports, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    const newState: any = { ...state };
    if (action.type === Actions.actions.SET_DAILY_VISITORS) {
        const reportPageAction = action as ISetActiveUsersGraphData;
        newState.DailyVisitorReport.dailyVisitorGraphData = reportPageAction.reportData;
    } else if (action.type === Actions.actions.SET_STUDENT_VISITORS) {
        const reportPageAction = action as ISetActiveUsersGraphData;
        newState.DailyVisitorReport.studentVisitorGraphData = reportPageAction.reportData;
    } else if (action.type === Actions.actions.SET_ACTIVE_STUDENTS) {
        const reportPageAction = action as ISetActiveStudentsData;
        newState.DailyVisitorReport.activeStudentsData = reportPageAction.reportData;
    } else if (action.type === Actions.actions.SET_FREQUENTLY_VISITED_COURSES) {
        const reportPageAction = action as ISetFrequentlyVisitedCoursesData;
        newState.DailyVisitorReport.frequentlyVisitedCoursesData = reportPageAction.reportData;
    } else if (action.type === Actions.actions.SET_TOTAL_VISITORS) {
        const reportPageAction = action as ISetActiveStudentsData;
        newState.DailyVisitorReport.totalVisitorsData = reportPageAction.reportData;
    } else if (action.type === Actions.actions.SET_VIRTUAL_CLASS_VIEW_STATS) {
        const reportPageAction = action as ISetVirtualClassViewsData;
        const virtualClassAsyncViewsData =
            reportPageAction.reportData && reportPageAction.reportData.length
                ? reportPageAction.reportData.map((item: any) => ({
                      date: item.date,
                      count: item.replayDuration
                  }))
                : [];
        const virtualClassSyncViewsData =
            reportPageAction.reportData && reportPageAction.reportData.length
                ? reportPageAction.reportData.map((item: any) => ({
                      date: item.date,
                      count: item.liveDuration
                  }))
                : [];
        newState.DailyVisitorReport.virtualClassAsyncViewsData = virtualClassAsyncViewsData;
        newState.DailyVisitorReport.virtualClassSyncViewsData = virtualClassSyncViewsData;
    }
    return Object.assign({}, state, newState);
};

export default reportReducer;
